import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Mint from "./pages/Mint";
import Header from "./components/Header";
import "./App.scss";

function App() {
	return (
		<div className="App">
			<Header />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/minting" element={<Mint />} />
			</Routes>
		</div>
	);
}

export default App;
